import { render, staticRenderFns } from "./PromoteSignature.vue?vue&type=template&id=4680400f"
import script from "./PromoteSignature.vue?vue&type=script&lang=js"
export * from "./PromoteSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports